import React, { useState, useEffect } from 'react';
import { Line } from '@ant-design/plots';
import Loader from '../../../utils/Loader';

const SummaryLineChart = ({ summaryReport, loading }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (summaryReport) {
      const chartData = summaryReport.rows;
      setConfig(chartData);
    }
  }, [summaryReport]);

  return (
    <div
      className={`${
        summaryReport && summaryReport.colCount ? summaryReport.colCount : ''
      } mb-3`}
    >
      {loading && <Loader />}
      {config && config.data ? <Line {...config} /> : null}
    </div>
  );
};

export default SummaryLineChart;
